








































































import { Route } from 'vue-router';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { mdiFacebook } from '@mdi/js';

@Component
export default class Footer extends Vue {

  private icons = { mdiFacebook };

  /**
   * Vue app title.
   */
  get title(): string {
    return process.env.VUE_APP_TITLE;
  }

  /**
   * Is the user authenticated.
   */
  get isAuth(): boolean {
    return this.$store.state.user != null;
  }

  /**
   * Is the current page the login page.
   */
  get isLoginPage(): boolean {
    return this.currentRouteName === 'login';
  }

  private currentRouteName: string|null = null;

  /** Should the email be shown. Used to add timeout on email display. */
  private showEmail = false;

  mounted() {
    this.routeUpdate(this.$route);
    setTimeout(() => { this.showEmail = true; }, 1000);
  }

  @Watch('$route')
  routeUpdate(to: Route) {
    this.currentRouteName = to.name ?? null;
  }

  //region EMAIL PROTECTION

  /** User email first part (protected) */
  private user = "jerome.bellon.couteau";

  /** User email second part (protected) */
  private domain = "gmail.com";

  /** Return protected email with display none elements. */
  private get protectedEmail(): string {
    if (!this.showEmail) {
      return "";
    }
    const displayNone = '<div style="display: none;">fake@email.com</div>';
    return [this.user, this.domain].join(`${displayNone}@${displayNone}`);
  }

  /** Simulate mailto click event. */
  private emailClicked() {
    window.location.href = 'mailto:' + [this.user, this.domain].join(`@`);
  }

  //endregion

}
